import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Box, Container, Divider, Grid, Typography, Checkbox, makeStyles, TextField, Button } from '@material-ui/core';
import CustomBreadcrumbs from '../Breadcrumb';
import { getNgReviews, ResolveNgReviews } from '../../ReduxStore/CreatePlanSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const useStyles = makeStyles((theme) => ({
    highlighted: {
        backgroundColor: theme.palette.action.hover,
    },
}));

const PVngchechpoints = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];
    // const [checkedState, setCheckedState] = useState({});
    // const [reviewComments, setReviewComments] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectAll, setSelectAll] = useState(false);
    const [NgCheckpoints, setNgCheckpoint] = useState(true);
    const [reviewComments, setReviewComments] = useState([]);
    const [checkedState, setCheckedState] = useState([]);
    const Role = localStorage.getItem("userRole");


    const handleCheckboxChange = (index) => {
        const updatedCheckedState = [...checkedState];
        updatedCheckedState[index] = !updatedCheckedState[index];
        setCheckedState(updatedCheckedState);

        const allChecked = updatedCheckedState.every(Boolean);
        setSelectAll(allChecked);
    };


    const handleSelectAllChange = (event) => {
        const checked = event.target.checked;
        setSelectAll(checked);

        const updatedCheckedState = NgCheckpoints.map(() => checked);
        setCheckedState(updatedCheckedState);
    };

    const handleReviewCommentChange = (index, value) => {
        const updatedComments = [...reviewComments];
        updatedComments[index] = value;
        setReviewComments(updatedComments);
    };


    const handleSubmit = async () => {

        if (Role === 'admin' || Role === 'supplier') {
            const ngResolvePayload = NgCheckpoints
                .map((item, index) => {
                    if (checkedState[index]) {
                        return {
                            log_id: item.log_id,
                            reviewed_comment: reviewComments[index] || ''
                        };
                    }
                    return null;
                })
                .filter(item => item !== null);

            const payload = {
                ng_resolve: ngResolvePayload
            };
            const action = dispatch(ResolveNgReviews(payload));
            const res = await action.unwrap();
            console.log("response", res);
            if (res.StatusCode === 201) {
                toast.success("Success");
                getNgReview();
            } else {
                toast.error("Something went wrong");
            }
        } else {
            toast.info("You don't have access to do this activity!")
        }

    };



    // const getNgReview = async () => {
    //     const action = dispatch(getNgReviews());
    //     const res = await action.unwrap();
    //     setNgCheckpoint(res.result.ng_reviews);
    // }

    const getNgReview = async () => {
        try {
            const action = dispatch(getNgReviews());
            const res = await action.unwrap();
            if (res.result) {
                setNgCheckpoint(res.result.ng_reviews);
            }
        } catch (error) {
            toast.error(error.message || "Something went Wrong!");
        }

    }


    useEffect(() => {
        const fetchData = async () => {
            await getNgReview();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        NG Checkpoints
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="NG Checkpoints" />
                </Box>
                <Box mb={2}>
                    {
                        NgCheckpoints.length === 0 ?
                            (<Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                                <Typography variant="h5">No NG Checkpoints</Typography>
                            </Box>) : (
                                <div className="checkpoint-box">
                                    <Box className="table-container">
                                        <Grid container spacing={3} className="checkpoint-header" alignItems="center">
                                            <Grid item xs={1}>
                                                <Checkbox
                                                    checked={selectAll}
                                                    onChange={handleSelectAllChange}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <h3>Checkpoints</h3>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <h3>Asset</h3>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <h3>RFID NO</h3>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <h3>Part No</h3>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <h3>Review Comment</h3>
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                        <Box className="table-content">
                                            {NgCheckpoints && NgCheckpoints.map((item, index) => {
                                                const assetDetails = item.assetMaster_details[item.asset_id];
                                                return (
                                                    <React.Fragment key={index}>
                                                        <Grid
                                                            container
                                                            spacing={2}
                                                            alignItems="center"
                                                            className={`checkpoint-item ${checkedState[index] ? classes.highlighted : ''}`}
                                                        >
                                                            <Grid item xs={1}>
                                                                <Checkbox
                                                                    checked={checkedState[index] || false}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                {item.check_point}
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                {assetDetails?.asset_text} ({(assetDetails.asset_no)?.slice(3)})
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                {item.rfidNo}
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                {assetDetails?.material_no}
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <TextField
                                                                    fullWidth
                                                                    placeholder="Enter Comment"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    value={reviewComments[index] || ''}
                                                                    onChange={(e) => handleReviewCommentChange(index, e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                    <Box mt={2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            Submit
                                        </Button>
                                    </Box>
                                </div>
                            )
                    }

                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default PVngchechpoints;
